import styled from "styled-components";

export const AddinInfo = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0.5rem .4rem 0.5rem .4rem;
`

export const AddinPublisher = styled.a`
    text-align: center;
`

export const AddinVersion = styled.p`
    text-align: center;
`

export const AddinDesc = styled.div`
    text-align: center;
`
